import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
import Slider from "./../Slider.vue";
import { toast as _toast, showLoading as _showLoading, hideLoading } from '@ykz/ykz-util/base';
export default {
  name: 'envelopeCoupon',
  components: {
    Slider: Slider
  },
  data: function data() {
    return {
      showEnvelopeCoupon: false,
      envelopeCouponSlideDown: true,
      // 弹窗是否滑下，默认为true
      envelopeList: [{
        name: '红包可抵3.8元',
        value: 3.8
      }, {
        name: '红包可抵5.0元',
        value: 5.0
      }],
      couponList: [{
        value: 1000,
        isDisabled: false
      }, {
        value: 500,
        isDisabled: true
      }]
    };
  },
  watch: {
    showOffline: function showOffline(val) {
      !this.isOtherBrowser && this.setOverflow(val);
    },
    showRecommendBox: function showRecommendBox(val) {
      this.setOverflow(val);
    }
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    window.componentCenter.envelopeCoupon = this;
    console.log('ycf组件初始化：envelopeCoupon');
    // this.getRecommendList();
  },

  methods: {
    //兼容ios系统的overflow对z-index层级关系的影响
    setOverflow: function setOverflow(val) {
      if (val) {
        $('.scroll-area').css('overflow-y', 'hidden');
      } else {
        $('.scroll-area').css('overflow-y', 'auto');
      }
    },
    //toast
    toast: function toast(str) {
      _toast(str);
    },
    //Loading
    showLoading: function showLoading() {
      _showLoading({
        cover: true,
        opacity: 0
      });
    },
    //向上滑动显示相关推荐弹框弹框
    slideUpEnvelopeCoupon: function slideUpEnvelopeCoupon(_this) {
      this._this != _this && (this._this = _this || {});
      var that = this;
      that.showEnvelopeCoupon = true;
      setTimeout(function () {
        that.envelopeCouponSlideDown = false;
      }, 30);
    },
    //向下滑动隐藏相关推荐弹框弹框
    slideDownEnvelopeCoupon: function slideDownEnvelopeCoupon() {
      var that = this;
      that.envelopeCouponSlideDown = true;
      setTimeout(function () {
        that.showEnvelopeCoupon = false;
      }, 300);
    }
  }
};